if (!customElements.get('cart-academy-add-person')) {
  customElements.define('cart-academy-add-person', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this._onClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }
    _onClick = (e) => {
      e.preventDefault();
      const form = document.querySelector('cart-academy-form');
      if (form) form.openForVariant(this.dataset.variantId);
    }
  });
}

if (!customElements.get('cart-academy-form')) {
  customElements.define('cart-academy-form', class extends HTMLElement {
    connectedCallback() {
      this._modalId = this.dataset.modalId || 'cart-academy-customer-data-modal';
      this._prefix = this.dataset.prefix || 'cart-acf';
      this._radioName = this.dataset.radioName || 'cart_document_type';
      this._redirect = this.dataset.redirect || '';

      this._inputSuffixes = ['name','company','region','email','phone','nip'];

      requestAnimationFrame(() => this._init());
    }

    _init() {
      this.modal = document.getElementById(this._modalId);
      if (!this.modal) return;

      this.submitBtn = this.modal.querySelector('#' + this._prefix + '-submit');
      this.nipField = this.modal.querySelector('#' + this._prefix + '-nip-field');

      this.modal.querySelectorAll('input[name="' + this._radioName + '"]').forEach(radio => {
        radio.addEventListener('change', this._onDocTypeChange);
      });

      if (this.submitBtn) {
        this.submitBtn.addEventListener('click', this._onSubmit);
      }
    }

    disconnectedCallback() {
      if (!this.modal) return;
      this.modal.querySelectorAll('input[name="' + this._radioName + '"]').forEach(radio => {
        radio.removeEventListener('change', this._onDocTypeChange);
      });
      if (this.submitBtn) {
        this.submitBtn.removeEventListener('click', this._onSubmit);
      }
    }

    openForVariant(variantId) {
      if (!this.modal) this.modal = document.getElementById(this._modalId);
      if (!this.modal) return;
      if (!this.submitBtn) {
        this.submitBtn = this.modal.querySelector('#' + this._prefix + '-submit');
        this.nipField = this.modal.querySelector('#' + this._prefix + '-nip-field');
        this.modal.querySelectorAll('input[name="' + this._radioName + '"]').forEach(radio => {
          radio.addEventListener('change', this._onDocTypeChange);
        });
        if (this.submitBtn) this.submitBtn.addEventListener('click', this._onSubmit);
      }
      this.modal.dataset.activeVariantId = variantId;
      this._resetForm();
      this.modal.open();
    }

    _resetForm() {
      const p = this._prefix;
      this._inputSuffixes.forEach(suffix => {
        const el = this.modal.querySelector('#' + p + '-' + suffix);
        if (el) { el.value = ''; el.classList.remove('invalid'); }
        const err = this.modal.querySelector('#' + p + '-' + suffix + '-error');
        if (err) err.classList.remove('visible');
      });
      const notes = this.modal.querySelector('#' + p + '-notes');
      if (notes) notes.value = '';
      const confirmCheckbox = this.modal.querySelector('#' + p + '-confirm-profession');
      if (confirmCheckbox) confirmCheckbox.checked = false;
      const confirmError = this.modal.querySelector('#' + p + '-confirm-profession-error');
      if (confirmError) confirmError.classList.remove('visible');
      const receiptRadio = this.modal.querySelector('input[name="' + this._radioName + '"][value="receipt"]');
      if (receiptRadio) receiptRadio.checked = true;
      if (this.nipField) this.nipField.style.display = 'none';
    }

    _onDocTypeChange = (e) => {
      if (this.nipField) {
        this.nipField.style.display = e.target.value === 'invoice' ? '' : 'none';
        if (e.target.value !== 'invoice') {
          const nipInput = this.modal.querySelector('#' + this._prefix + '-nip');
          const nipError = this.modal.querySelector('#' + this._prefix + '-nip-error');
          if (nipInput) { nipInput.value = ''; nipInput.classList.remove('invalid'); }
          if (nipError) nipError.classList.remove('visible');
        }
      }
    }

    _onSubmit = () => {
      const p = this._prefix;
      const isInvoice = this.modal.querySelector('input[name="' + this._radioName + '"]:checked').value === 'invoice';

      const labels = this.dataset;
      const fields = [
        { suffix: 'name', key: labels.labelName, required: true },
        { suffix: 'company', key: labels.labelCompany, required: true },
        { suffix: 'region', key: labels.labelRegion, required: true },
        { suffix: 'email', key: labels.labelEmail, required: true, type: 'email' },
        { suffix: 'phone', key: labels.labelPhone, required: true, type: 'phone' },
        { suffix: 'nip', key: labels.labelNip, required: isInvoice, type: 'nip' }
      ];

      let valid = true;
      const properties = {};

      fields.forEach(field => {
        const id = p + '-' + field.suffix;
        const input = this.modal.querySelector('#' + id);
        const error = this.modal.querySelector('#' + id + '-error');
        const value = input.value.trim();

        input.classList.remove('invalid');
        if (error) error.classList.remove('visible');

        if (field.required && !value) {
          valid = false;
          input.classList.add('invalid');
          if (error) error.classList.add('visible');
          return;
        }

        if (field.type === 'email' && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          valid = false;
          input.classList.add('invalid');
          if (error) error.classList.add('visible');
          return;
        }

        if (field.type === 'phone' && value && !/^[\d\s\-\+\(\)]{7,}$/.test(value)) {
          valid = false;
          input.classList.add('invalid');
          if (error) error.classList.add('visible');
          return;
        }

        if (field.type === 'nip' && value && !/^\d{10}$/.test(value.replace(/[\s\-]/g, ''))) {
          valid = false;
          input.classList.add('invalid');
          if (error) error.classList.add('visible');
          return;
        }

        if (value) properties[field.key] = value;
      });

      const notesValue = this.modal.querySelector('#' + p + '-notes').value.trim();
      if (notesValue) properties[labels.labelNotes] = notesValue;

      const confirmCheckbox = this.modal.querySelector('#' + p + '-confirm-profession');
      const confirmError = this.modal.querySelector('#' + p + '-confirm-profession-error');
      if (confirmError) confirmError.classList.remove('visible');
      if (confirmCheckbox && !confirmCheckbox.checked) {
        valid = false;
        if (confirmError) confirmError.classList.add('visible');
      } else if (confirmCheckbox && confirmCheckbox.checked) {
        properties[labels.labelConfirmProfession] = labels.labelConfirmProfessionYes;
      }

      const docType = this.modal.querySelector('input[name="' + this._radioName + '"]:checked').value;
      properties[labels.labelDocumentType] = docType === 'invoice' ? labels.labelInvoice : labels.labelReceipt;

      if (!valid) return;

      const variantId = this.modal.dataset.activeVariantId;
      const textEl = this.submitBtn.querySelector('span');
      const spinnerEl = this.submitBtn.querySelector('.loading__spinner');
      if (textEl) textEl.classList.add('hidden');
      if (spinnerEl) spinnerEl.classList.remove('hidden');
      this.submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1, properties }] })
      })
      .then(res => res.json())
      .then(() => {
        if (this._redirect) {
          window.location.href = this._redirect;
        } else {
          window.location.reload();
        }
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        if (textEl) textEl.classList.remove('hidden');
        if (spinnerEl) spinnerEl.classList.add('hidden');
        this.submitBtn.disabled = false;
      });
    }
  });
}

if (!customElements.get('academy-direct-add-to-cart')) {
  customElements.define('academy-direct-add-to-cart', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this._onClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }
    _onClick = (e) => {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      const redirect = this.dataset.redirect || '/cart';
      const btn = this.querySelector('a, button') || this;
      const textEl = btn.querySelector('span');
      const spinnerEl = btn.querySelector('.loading__spinner');

      if (textEl) textEl.classList.add('hidden');
      if (spinnerEl) spinnerEl.classList.remove('hidden');
      btn.style.pointerEvents = 'none';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(res => res.json())
      .then(() => { window.location.href = redirect; })
      .catch(err => {
        console.error('Add to cart error:', err);
        if (textEl) textEl.classList.remove('hidden');
        if (spinnerEl) spinnerEl.classList.add('hidden');
        btn.style.pointerEvents = '';
      });
    }
  });
}
